// extracted by mini-css-extract-plugin
export default {"wishListsErrorContainer":"wishListsErrorContainer__f10cda"};